import { Controller } from '@hotwired/stimulus'
import { Dropdown } from 'bootstrap'

export default class extends Controller {
  static targets = ['frame']

  loadContent() {
    // Force reload the turbo frame by reloading its src
    if (this.hasFrameTarget) {
      const src = this.frameTarget.getAttribute('src')
      if (src) {
        // Reload the frame to get fresh data
        this.frameTarget.reload()
      }
    }
  }

  closeDropdown(event) {
    // Only close if the submission was successful
    if (event.detail.success) {
      // Find the Bootstrap dropdown toggle button
      const dropdownToggle = this.element.querySelector('[data-bs-toggle="dropdown"]')
      if (dropdownToggle) {
        const dropdown = Dropdown.getInstance(dropdownToggle)
        if (dropdown) {
          dropdown.hide()
        }
      }
    }
  }
}
